namespace Areas.Workflows {
    "use strict";
    
    let formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {
        formCrudOps = new FormCrudOperations("Workflows");
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function deleteRecord() {
        formCrudOps.deleteRecord();
    }

    export function markComplete() {
        const verifyMarkComplete =
            window.confirm("Are you sure you want to mark this workflow complete?");

        if (verifyMarkComplete) {
            const keyId: any = formCrudOps.form.option("KeyId");
            sendRequest(`/${formCrudOps.area}/Edit/MarkComplete/${keyId}`, "", "PUT");
        }
    }

    export function startProcess() {
        const verifyStart =
            window.confirm("Are you sure you would like to Start the Workflow Process for this record?");

        if (verifyStart) {
            formCrudOps.updateRecord(() => {
                const keyId: any = formCrudOps.form.option("KeyId");
                sendRequest(`/${formCrudOps.area}/Edit/StartProcess/${keyId}`, "", "PUT");
            });
        }
    }

    export function onCellPrepared(e) {
        if (e.rowType === "data" && e.column.command === "edit") {
            if (e.data.actionTaken) {
                e.cellElement.empty();
            }
        }
    }

}
